import * as React from "react";
import { useLocation } from "react-router-dom";
import protectedRoute from "./protectedRoute";
import {
  styled,
  alpha,
  createTheme,
  ThemeProvider,
} from "@mui/material/styles";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import HomeBar from "./HomeBar";
import {
  CssDataJacketTitleTypography,
  CssDataJacketBodyTypography,
  MainPageBox,
  SearchGrid,
} from "./styles/styled";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import ToggleButton from "@mui/material/ToggleButton";
import Pagination from "@mui/material/Pagination";
import { grey } from "@mui/material/colors";
import { PaginationItem } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Stack from "@mui/material/Stack";
import { relatedIndustryList } from "./graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import OutlinedInput from "@mui/material/OutlinedInput";
import ListItemText from "@mui/material/ListItemText";
import Botton from "@mui/material/Table";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import IconButton from "@mui/material/IconButton";
import { Auth, Hub } from "aws-amplify";
import {
  DataJacketIDList,
  getAllDataJacketDetails,
} from "./js/queriesHandling";
import { DataJacketCardComponent } from "./components/other/dataJacketCard";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Footer from "./Footer";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const SearchToggleButton = styled(ToggleButton)(({ theme }) => ({
  backgroundColor: "#505458",
  "&:hover": {
    background: alpha(theme.palette.common.white, 0.25),
  },
}));

const CssItem = styled(Item)(({ theme }) => ({
  backgroundColor: "black",
  "&:hover": {
    background: alpha(theme.palette.common.white, 0.25),
  },
}));

const customTheme = createTheme({
  palette: {
    primary: {
      main: "#171717",
      sub: grey[50],
      light: grey[50],
      dark: grey[900],
      constrastText: grey[50],
    },
    secondary: {
      main: grey[900],
    },
  },
});

const DataJacketPagination = styled(Pagination)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.light,
  "& .MuiPaginationItem-text": {
    color: theme.palette.primary.light,
  },
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  textAlign: "left",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#505458",
  "&:hover": {
    backgroundColor: "#75787b",
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    width: "auto",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  width: "calc(100% - 48px)",
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: "1em",
    transition: theme.transitions.create("width"),
    width: "100%",
    color: "white",
  },
}));

const CssSelect = styled(Select)(({ theme }) => ({
  color: "white",
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(228, 219, 233, 0.25)",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(228, 219, 233, 0.25)",
  },
  "&.Mui-focused .MuiInputLabel-root": {
    backgroundColor: "red !important",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(228, 219, 233, 0.25)",
  },
  ".MuiSvgIcon-root ": {
    fill: "white !important",
  },
  "&:hover": {
    backgroundColor: "#75787b",
  },
}));

const options = [
  "お気に入り登録が多い順",
  "最終更新日が新しい順",
  "発行日が新しい順",
  "対象期間が新しい順",
];

function DataJacketList(props) {
  const [compDataJacket, setCompDataJacket] = React.useState([]);
  const [page, setPage] = React.useState([]);
  const [objIndustryList, setIndustryList] = React.useState([]);
  const [displayJacket, setDisplayJacket] = React.useState(false);
  const [displayPaging, setDisplayPaging] = React.useState(false);
  const [totalJackets, setTotalJackets] = React.useState(0);
  const [pages, setPages] = React.useState(0);
  const [arrDataJacket, setArrDataJacket] = React.useState([]);
  const [user, setUser] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [price, setPrice] = React.useState("");
  const [bookmarked, setBookmarked] = React.useState(false);
  const [relatedIndustry, setRelatedIndustry] = React.useState("未指定");
  const [keyword, setKeyword] = React.useState("");
  const [keywordClear, setKeywordClear] = React.useState(false);
  const [industryClear, setIndustryClear] = React.useState(false);
  const [optionName, setOptionName] = React.useState([]);
  const [prevSortOrder, setPrevSortOrder] = React.useState(options[0]);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [maxHeight, setMaxHeight] = React.useState(0);
  const ref = React.useRef([]);
  const [loading, setLoading] = React.useState(true);
  const [isFetching, setIsFetching] = React.useState(true);
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 900,
        width: 350,
      },
    },
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setOptionName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    setRelatedIndustry(event.target.value);
  };

  const handleMenuItemClick = (event, index) => {
    setPrevSortOrder(options[selectedIndex]);
    setCurrentPage(1);
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function displayCheckmarks(objIndustryList) {
    let menu = [];
    objIndustryList.map((name) =>
      menu.push(
        <MenuItem style={{ height: "35px" }} key={name.key} value={name.key}>
          <Checkbox checked={optionName.indexOf(name.key) > -1} />
          <ListItemText primary={name} />
        </MenuItem>
      )
    );
    return menu;
  }

  //Reset Page Position after redirect, page change and sort order change---
  //Change all data jacket cards' height to the highest one---
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    try {
      setTimeout(function () {
        if (totalJackets > 0) {
          let currentMaxHeight = 0;
          for (let i = 0; i < compDataJacket.length; i++) {
            if (i === 0) {
              currentMaxHeight = ref[i].offsetHeight;
            } else if (ref[i].offsetHeight > currentMaxHeight) {
              currentMaxHeight = ref[i].offsetHeight;
            }
          }
          setMaxHeight(currentMaxHeight);
          if (maxHeight > 0) {
            for (let i = 0; i < compDataJacket.length; i++) {
              ref[i].style.height = currentMaxHeight + "px";
            }
          }
        }
      }, 1000);
    } catch (e) {}
  }, [compDataJacket, pathname, maxHeight]);
  //Change all data jacket cards' height to the highest one---
  //Reset Page Position after redirect, page change and sort order change---

  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (options[selectedIndex] !== prevSortOrder) {
      searchJacket();
    }
  }, [selectedIndex]);

  function EraseAllCheck(objIndustryList) {
    let remove = [];
    let menu = [];
    setOptionName(remove);
    setRelatedIndustry(remove);
    objIndustryList.map((name) =>
      menu.push(
        <MenuItem style={{ height: "35px" }} key={name.key} value={name.key}>
          <Checkbox checked={false} />
          <ListItemText primary={name} />
        </MenuItem>
      )
    );
    return menu;
  }

  function allFillterReset(objIndustryList) {
    let remove = [];
    let menu = [];
    setOptionName(remove);
    setRelatedIndustry(remove);
    objIndustryList.map(
      (name) =>
        menu.push(
          <MenuItem style={{ height: "35px" }} key={name.key} value={name.key}>
            <Checkbox checked={false} />
            <ListItemText primary={name} />
          </MenuItem>
        ),
      setIndustryClear(true)
    );
    if (keyword !== "") {
      setKeyword("");
      setKeywordClear(true);
    }
    if (price !== "") {
      setPrice("");
    }
    if (true === bookmarked) {
      setBookmarked(false);
    }
    setSelectedIndex(0);
    return menu;
  }
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    DataJacketIDList(
      value,
      price,
      user ? user.username : "",
      bookmarked,
      relatedIndustry.toString(),
      keyword,
      options[selectedIndex]
    ).then((evt) => {
      setArrDataJacket(evt);
    });
  };

  const handleCheckChange = (event) => {
    if (true === event.target.checked) setPrice("無償");
    else setPrice("");
  };

  const handleCheckChangeBookmarked = (event) => {
    if (true === event.target.checked) {
      setBookmarked(true);
    } else {
      setBookmarked(false);
    }
  };

  React.useEffect(() => {
    searchJacket();
  }, [price, bookmarked]);

  React.useEffect(() => {
    if (industryClear === true) {
      searchJacket();
    }
  }, [keywordClear, industryClear]);

  const searchJacket = () => {
    setIsFetching(true);
    setCurrentPage(1);
    DataJacketIDList(
      0,
      price,
      user ? user.username : "",
      bookmarked,
      relatedIndustry.toString(),
      keyword,
      options[selectedIndex]
    )
      .then((evt) => {
        if (evt.length === 1 && evt[0] === "") {
          processErrorOrNoResult();
        } else {
          if (evt.length > 12) {
            setDisplayPaging(true);
            setPages(Math.ceil(evt.length / 12));
          } else {
            setDisplayPaging(false);
            setPages(0);
          }
          let arrFirstPageIds = [12];
          for (var i = 0; i < evt.length && i < 12; i++) {
            arrFirstPageIds[i] = evt[i];
          }
          setArrDataJacket(arrFirstPageIds);
          setTotalJackets(evt.length);
        }
      })
      .catch((err) => {
        processErrorOrNoResult();
      });
    setDisplayJacket((prev) => (prev === false ? !prev : prev));
    setKeywordClear(false);
    setIndustryClear(false);
  };

  function processErrorOrNoResult() {
    setCompDataJacket(
      <CssDataJacketTitleTypography>
        該当結果がありません。
      </CssDataJacketTitleTypography>
    );
    setCurrentPage(0);
    setTotalJackets(0);
    setDisplayPaging(false);
  }
  async function checkUser() {
    try {
      const data = await Auth.currentUserPoolUser();
      const userInfo = { username: data.username, ...data.attributes };
      setUser(userInfo);
      Auth.currentSession().then().catch();
    } catch (err) {}
  }

  async function getFilterCondition() {
    try {
      API.graphql(graphqlOperation(relatedIndustryList, { empty: null })).then(
        (evt) => {
          const list = [];
          for (const item of evt.data.relatedIndustryList.list.split(",")) {
            list.push(
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            );
          }
          setIndustryList(list);
        }
      );
    } catch (e) {}
  }

  async function renderPaging() {
    if (
      pages === 0 ||
      displayJacket === false ||
      displayPaging === false ||
      totalJackets < 12
    ) {
      return <></>;
    } else {
      return (
        <Box
          component="span"
          style={{
            display: "block",
            paddingTop: "32px",
            paddingBottom: "32px",
          }}
        >
          <Grid
            container
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid container item>
              <CssDataJacketBodyTypography>Page</CssDataJacketBodyTypography>
            </Grid>
            <Grid container item>
              <DataJacketPagination
                style={{
                  backgroundColor: "#505458",
                }}
                theme={customTheme}
                count={pages}
                defaultPage={1}
                boundaryCount={2}
                page={currentPage}
                onChange={handlePageChange}
                renderItem={(item) => (
                  <PaginationItem
                    components={{
                      previous: ArrowBackIosIcon,
                      next: ArrowForwardIosIcon,
                    }}
                    {...item}
                    sx={{
                      color: "white",
                      "&.Mui-selected": {
                        backgroundColor: "#75787B",
                        color: "white",
                        borderColor: "transparent",
                        fontSize: 16,
                        height: "32px",
                        width: "32px",
                        borderRadius: "20px",
                      },
                      "&.MuiPaginationItem-root:hover": {
                        backgroundColor: "#75787B",
                      },
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Box>
      );
    }
  }

  async function getDataJacket() {
    setLoading(true);
    const returnDataJacket = await getAllDataJacketDetails(
      ["0000"].concat(arrDataJacket),
      user.username
    );
    setCompDataJacket(
      returnDataJacket.map((djInfo, index) => (
        <DataJacketCardComponent
          key={djInfo.key}
          jacketId={djInfo.jacketId}
          dataJacket={djInfo.datajacket}
          ref={(el) => (ref[index] = el)}
          user={user.username}
        />
      ))
    );
    setPage(await renderPaging());
    setLoading(false);
  }

  //ゲート３で解放
  React.useEffect(() => {
    setIsFetching(false); // エラーの場合もボタンを活性化
  }, [compDataJacket]);

  React.useEffect(() => {
    checkUser();
    Hub.listen("auth", (data) => {
      const { payload } = data;
      if (payload.event === "signOut") {
        setUser(null);
      }
    });
    searchJacket();
    getFilterCondition();
  }, []);

  React.useEffect(() => {
    try {
      if (
        (arrDataJacket.length > 0 || totalJackets > 0) &&
        displayJacket === true
      ) {
        getDataJacket();
      }
    } catch {}
  }, [arrDataJacket]);

  React.useEffect(() => {
    try {
      if (displayPaging === false) {
        setPage(<></>);
      }
    } catch {}
  }, [displayPaging]);

  if (user) {
    return (
      <React.Fragment>
        <HomeBar />
        <Container
          style={{
            backgroundColor: "#303234",
            minWidth: "1200px",
          }}
          maxWidth={false}
        >
          <MainPageBox>
            <Card
              component="span"
              style={{
                display: "block",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "48px",
                position: "sticky",
                backgroundColor: "#303234",
                top: "81px",
                zIndex: "4",
                boxShadow: "none",
              }}
            >
              <SearchGrid
                container
                spacing={2}
                style={{
                  borderRadius: "5px",
                  backgroundColor: "#505458",
                  paddingTop: "16px",
                  paddingBottom: "16px",
                  marginLeft: "32px",
                  marginRight: "32px",
                }}
              >
                <Grid
                  container
                  spacing={0}
                  style={{
                    borderRadius: "5px",
                    backgroundColor: "#505458",
                    paddingTop: "16px",
                    paddingBottom: "16px",
                    marginLeft: "32px",
                    marginRight: "32px",
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <Grid
                    style={{
                      width: "20%",
                      boxShadow: "none",
                      backgroundColor: "#505458",
                      display: "flex",
                    }}
                  >
                    <Item
                      style={{
                        width: "100%",
                        boxShadow: "none",
                        backgroundColor: "#505458",
                      }}
                    >
                      <FormControl
                        style={{
                          color: "white",
                          width: "100%",
                          border: "1px solid",
                          borderColor: "white",
                          borderRadius: "5px",
                        }}
                      >
                        <InputLabel
                          style={{
                            color: "white",
                            padding: "0 4px 0 4px",
                            fontFamily: "Noto Sans JP, Meiryo, -apple-system", // フォントを指定
                            "&:hover": {
                              backgroundColor: "transparent",
                            },
                          }}
                          sx={{
                            "&.MuiInputLabel-root.Mui-focused": {
                              backgroundColor: "#505458",
                            },
                            "&.MuiInputLabel-shrink": {
                              backgroundColor: "#505458",
                            },
                          }}
                          id="demo-simple-select-autowidth-label"
                        >
                          データの関連業種
                        </InputLabel>
                        <CssSelect
                          labelId="demo-multiple-checkbox-label"
                          id="demo-multiple-checkbox"
                          multiple
                          value={optionName}
                          onChange={handleChange}
                          input={<OutlinedInput label="Tag" />}
                          renderValue={(selected) => selected.join(", ")}
                          MenuProps={MenuProps}
                          style={{
                            fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                          }}
                        >
                          {displayCheckmarks(objIndustryList)}
                          <Box
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              paddingRight: "10px",
                            }}
                          >
                            <Botton
                              onClick={() => EraseAllCheck(objIndustryList)}
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                paddingRight: "10px",
                                color: "#00A3E0",
                                cursor: "pointer",
                                textDecoration: "underline",
                                textDecorationolor: "#00A3E0",
                                width: "40%",
                              }}
                            >
                              Reset fillters
                            </Botton>
                          </Box>
                        </CssSelect>
                      </FormControl>
                    </Item>
                  </Grid>
                  <Grid
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#505458",
                      width: "70%",
                    }}
                  >
                    <Search
                      style={{
                        border: "1px solid",
                        borderColor: "white",
                        width: "100%",
                      }}
                    >
                      <StyledInputBase
                        placeholder="検索キーワード（キーワード間にスペースを挟むことで複数指定可能）"
                        inputProps={{ "aria-label": "search" }}
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key == "Enter") {
                            searchJacket();
                          }
                        }}
                        style={{
                          height: "56px",
                          width: "100%",
                          fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                        }}
                      />
                    </Search>
                  </Grid>
                  <Grid
                    xs={1}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "10%",
                    }}
                  >
                    <SearchToggleButton
                      value="bold"
                      aria-label="bold"
                      disabled={isFetching}
                      style={{
                        border: "1px solid",
                        borderColor: "white",
                        width: "100%",
                        height: "58px",
                      }}
                      onClick={searchJacket}
                    >
                      <SearchIcon sx={{ color: "white" }} />
                    </SearchToggleButton>
                  </Grid>
                </Grid>
                <Grid
                  style={{
                    width: "100%",
                    marginLeft: "24px",
                    marginRight: "24px",
                    minWidth: "600px",
                  }}
                >
                  <Paper
                    style={{
                      border: "none",
                      margin: "0",
                      backgroundColor: "#505458",
                      maxWidth: "200px",
                    }}
                    variant="outlined"
                    sx={{ mt: 2, mx: 0, p: 2 }}
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      spacing={4}
                      height="20px"
                    >
                      <CssItem
                        style={{
                          width: "10%",
                          textAlign: "center",
                          alignItems: "center",
                          boxShadow: "none",
                          marginLeft: "0",
                          backgroundColor: "#505458",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <FormControlLabel
                          style={{
                            color: "white",
                            width: "100%",
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                          control={
                            <Checkbox
                              style={{
                                color: "white",
                              }}
                              checked={price}
                              onChange={handleCheckChange}
                            />
                          }
                          label={
                            // Typography コンポーネントでラップしてスタイルを適用
                            <Typography
                              style={{
                                fontFamily:
                                  "Noto Sans JP, Meiryo, -apple-system",
                              }}
                            >
                              無償のみ
                            </Typography>
                          }
                        />
                      </CssItem>
                      <CssItem
                        style={{
                          width: "10%",
                          textAlign: "center",
                          alignItems: "center",
                          boxShadow: "none",
                          marginLeft: "0",
                          backgroundColor: "#505458",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <FormControlLabel
                          style={{
                            color: "white",
                            width: "150%",
                            marginLeft: "auto",
                            marginRight: "auto",
                            fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                          }}
                          control={
                            <Checkbox
                              style={{
                                color: "white",
                              }}
                              onChange={handleCheckChangeBookmarked}
                              checked={bookmarked}
                            />
                          }
                          label={
                            // Typography コンポーネントでラップしてスタイルを適用
                            <Typography
                              style={{
                                fontFamily:
                                  "Noto Sans JP, Meiryo, -apple-system",
                              }}
                            >
                              お気に入り登録済み
                            </Typography>
                          }
                        />
                      </CssItem>
                    </Stack>
                  </Paper>
                </Grid>
              </SearchGrid>
              <Box
                component="span"
                style={{
                  display: "flex",
                  alignItems: "right",
                  justifyContent: "right",
                  marginTop: "16px",
                  marginRight: "16px",
                  marginBottom: "12px",
                  height: "48px",
                }}
              >
                <IconButton
                  style={{ fontSize: "16px", marginTop: 0, color: "white" }}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#75787B",
                    },
                    borderRadius: "5px",
                  }}
                  size="medium"
                  ref={anchorRef}
                  aria-controls={open ? "split-button-menu" : undefined}
                  aria-expanded={open ? "true" : undefined}
                  aria-label="select merge strategy"
                  aria-haspopup="menu"
                  onClick={handleToggle}
                >
                  <VerticalAlignBottomIcon />
                  {options[selectedIndex]}
                </IconButton>
                <Popper
                  sx={{
                    zIndex: 1,
                  }}
                  open={open}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom"
                            ? "center top"
                            : "center bottom",
                      }}
                    >
                      <Paper
                        style={{ backgroundColor: "#505458", color: "white" }}
                      >
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList id="split-button-menu" autoFocusItem>
                            {options.map((option, index) => (
                              <MenuItem
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "#75787B",
                                  },
                                  "&.MuiMenuItem-root.Mui-selected": {
                                    backgroundColor: "#75787B",
                                  },
                                }}
                                key={option}
                                selected={index === selectedIndex}
                                onClick={(event) =>
                                  handleMenuItemClick(event, index)
                                }
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
                <CssDataJacketBodyTypography
                  style={{
                    fontSize: "16px",
                    display: "inline",
                    marginLeft: "0",
                    marginTop: "4px",
                    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                  }}
                >
                  {parseInt(totalJackets) > 0
                    ? (currentPage - 1) * 12 +
                      1 +
                      "-" +
                      (currentPage * 12 > parseInt(totalJackets)
                        ? parseInt(totalJackets)
                        : currentPage * 12)
                    : "0"}
                  /{parseInt(totalJackets) > 0 ? parseInt(totalJackets) : "0"}{" "}
                  表示
                </CssDataJacketBodyTypography>
                <Button
                  disableRipple
                  onClick={() => allFillterReset(objIndustryList)}
                  style={{
                    fontSize: "16px",
                    paddingRight: "30px",
                    color: "#00A3E0",
                    backgroundColor: "transparent",
                    cursor: "pointer",
                    textDecoration: "underline",
                    textDecorationolor: "#00A3E0",
                    textTransform: "none",
                    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                  }}
                >
                  Reset fillters
                </Button>
              </Box>
            </Card>
            {loading ? (
              <Modal
                open={loading}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <ThemeProvider theme={customTheme}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100vh", // 画面全体の高さを基準にするために使用
                    }}
                  >
                    <Box
                      sx={{
                        border: "solid 1px #666666",
                        position: "absolute",
                        backgroundColor: "#303234",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "70%",
                        height: "200px",
                      }}
                    >
                      <CircularProgress
                        style={{
                          color: "#505458",
                          width: "70px",
                          height: "70px",
                        }}
                      />
                      <CssDataJacketBodyTypography
                        display="inline"
                        style={{ fontSize: "16px" }}
                      >
                        データ取得中・・・
                      </CssDataJacketBodyTypography>
                    </Box>
                  </Box>
                </ThemeProvider>
              </Modal>
            ) : (
              <Grid
                style={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  paddingLeft: "32px",
                  paddingRight: "32px",
                }}
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 6, sm: 9, md: 9 }}
              >
                {compDataJacket}
              </Grid>
            )}
            {page}
          </MainPageBox>
          <Box
            style={{
              backgroundColor: "#505458",
              overflowY: "scroll",
              scrollbarWidth: "thin",
            }}
          ></Box>
        </Container>
        <Footer />
      </React.Fragment>
    );
  }
}

export default protectedRoute(DataJacketList);
